export const EXAMINATION_SAGA = 'EXAMINATION_SAGA';

export const examinationAction = () => ({ type: EXAMINATION_SAGA });



// WEBPACK FOOTER //
// ./src/actions/examination.js